// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  AddModuleToCourseBody,
  CourseModuleUpdateRequest,
  GenericApiResponseCourseModuleSettings,
  GenericApiResponseCourseModuleSummary,
  GenericApiResponseModuleUpgradeAcceptResponse,
  GenericApiResponseNoneType,
  HTTPValidationError,
  ModuleUpgradeAcceptRequest,
} from '../../models';

/**
 * Add a module to a course.

If segment_id is provided, adds the module to that segment's order.
If no segment_id is provided but the course has segments, adds to the first segment.
 * @summary Add Module To Course
 */
export const addModuleToCourse = (
  courseId: string,
  moduleId: string,
  addModuleToCourseBody: AddModuleToCourseBody,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCourseModuleSummary>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}`, addModuleToCourseBody, options);
};

export const getAddModuleToCourseMutationOptions = <
  TData = Awaited<ReturnType<typeof addModuleToCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: AddModuleToCourseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['addModuleToCourse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addModuleToCourse>>,
    { courseId: string; moduleId: string; data: AddModuleToCourseBody }
  > = (props) => {
    const { courseId, moduleId, data } = props ?? {};

    return addModuleToCourse(courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: AddModuleToCourseBody },
    TContext
  >;
};

export type AddModuleToCourseMutationResult = NonNullable<Awaited<ReturnType<typeof addModuleToCourse>>>;
export type AddModuleToCourseMutationBody = AddModuleToCourseBody;
export type AddModuleToCourseMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Add Module To Course
 */
export const useAddModuleToCourse = <
  TData = Awaited<ReturnType<typeof addModuleToCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: AddModuleToCourseBody },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string; data: AddModuleToCourseBody }, TContext> => {
  const mutationOptions = getAddModuleToCourseMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Remove a module from a course.

Removes from the main module list AND cleans up references in segments.
 * @summary Remove Module From Course
 */
export const removeModuleFromCourse = (
  courseId: string,
  moduleId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseNoneType>> => {
  return axios.delete(`/courses/${courseId}/modules/${moduleId}`, options);
};

export const getRemoveModuleFromCourseMutationOptions = <
  TData = Awaited<ReturnType<typeof removeModuleFromCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['removeModuleFromCourse'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeModuleFromCourse>>,
    { courseId: string; moduleId: string }
  > = (props) => {
    const { courseId, moduleId } = props ?? {};

    return removeModuleFromCourse(courseId, moduleId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string },
    TContext
  >;
};

export type RemoveModuleFromCourseMutationResult = NonNullable<Awaited<ReturnType<typeof removeModuleFromCourse>>>;

export type RemoveModuleFromCourseMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Remove Module From Course
 */
export const useRemoveModuleFromCourse = <
  TData = Awaited<ReturnType<typeof removeModuleFromCourse>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { courseId: string; moduleId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { courseId: string; moduleId: string }, TContext> => {
  const mutationOptions = getRemoveModuleFromCourseMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Update module settings in a course
 * @summary Update Coursemodule Settings
 */
export const updateCoursemodule = (
  courseId: string,
  moduleId: string,
  courseModuleUpdateRequest: CourseModuleUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCourseModuleSettings>> => {
  return axios.put(`/courses/${courseId}/modules/${moduleId}`, courseModuleUpdateRequest, options);
};

export const getUpdateCoursemoduleMutationOptions = <
  TData = Awaited<ReturnType<typeof updateCoursemodule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: CourseModuleUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateCoursemodule'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCoursemodule>>,
    { courseId: string; moduleId: string; data: CourseModuleUpdateRequest }
  > = (props) => {
    const { courseId, moduleId, data } = props ?? {};

    return updateCoursemodule(courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: CourseModuleUpdateRequest },
    TContext
  >;
};

export type UpdateCoursemoduleMutationResult = NonNullable<Awaited<ReturnType<typeof updateCoursemodule>>>;
export type UpdateCoursemoduleMutationBody = CourseModuleUpdateRequest;
export type UpdateCoursemoduleMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Update Coursemodule Settings
 */
export const useUpdateCoursemodule = <
  TData = Awaited<ReturnType<typeof updateCoursemodule>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: CourseModuleUpdateRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; data: CourseModuleUpdateRequest },
  TContext
> => {
  const mutationOptions = getUpdateCoursemoduleMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student accepts an offered module version upgrade for this course enrollment.
 * @summary Accept Module Version Upgrade
 */
export const acceptModuleVersionUpgrade = (
  courseId: string,
  moduleId: string,
  moduleUpgradeAcceptRequest: ModuleUpgradeAcceptRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleUpgradeAcceptResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/upgrade`, moduleUpgradeAcceptRequest, options);
};

export const getAcceptModuleVersionUpgradeMutationOptions = <
  TData = Awaited<ReturnType<typeof acceptModuleVersionUpgrade>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['acceptModuleVersionUpgrade'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptModuleVersionUpgrade>>,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest }
  > = (props) => {
    const { courseId, moduleId, data } = props ?? {};

    return acceptModuleVersionUpgrade(courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
};

export type AcceptModuleVersionUpgradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptModuleVersionUpgrade>>
>;
export type AcceptModuleVersionUpgradeMutationBody = ModuleUpgradeAcceptRequest;
export type AcceptModuleVersionUpgradeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Accept Module Version Upgrade
 */
export const useAcceptModuleVersionUpgrade = <
  TData = Awaited<ReturnType<typeof acceptModuleVersionUpgrade>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
  TContext
> => {
  const mutationOptions = getAcceptModuleVersionUpgradeMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Student declines an upgrade offer; they will not be prompted again for this version.
 * @summary Dismiss Module Version Upgrade
 */
export const dismissModuleVersionUpgrade = (
  courseId: string,
  moduleId: string,
  moduleUpgradeAcceptRequest: ModuleUpgradeAcceptRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseModuleUpgradeAcceptResponse>> => {
  return axios.post(`/courses/${courseId}/modules/${moduleId}/upgrade/dismiss`, moduleUpgradeAcceptRequest, options);
};

export const getDismissModuleVersionUpgradeMutationOptions = <
  TData = Awaited<ReturnType<typeof dismissModuleVersionUpgrade>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['dismissModuleVersionUpgrade'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof dismissModuleVersionUpgrade>>,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest }
  > = (props) => {
    const { courseId, moduleId, data } = props ?? {};

    return dismissModuleVersionUpgrade(courseId, moduleId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
};

export type DismissModuleVersionUpgradeMutationResult = NonNullable<
  Awaited<ReturnType<typeof dismissModuleVersionUpgrade>>
>;
export type DismissModuleVersionUpgradeMutationBody = ModuleUpgradeAcceptRequest;
export type DismissModuleVersionUpgradeMutationError = AxiosError<HTTPValidationError>;

/**
 * @summary Dismiss Module Version Upgrade
 */
export const useDismissModuleVersionUpgrade = <
  TData = Awaited<ReturnType<typeof dismissModuleVersionUpgrade>>,
  TError = AxiosError<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  TData,
  TError,
  { courseId: string; moduleId: string; data: ModuleUpgradeAcceptRequest },
  TContext
> => {
  const mutationOptions = getDismissModuleVersionUpgradeMutationOptions(options);

  return useMutation(mutationOptions);
};
